import { render, staticRenderFns } from "./ProvisioningResultButton.vue?vue&type=template&id=481ef1f4&scoped=true"
import script from "./ProvisioningResultButton.vue?vue&type=script&lang=js"
export * from "./ProvisioningResultButton.vue?vue&type=script&lang=js"
import style0 from "./ProvisioningResultButton.vue?vue&type=style&index=0&id=481ef1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ef1f4",
  null
  
)

export default component.exports